import React, {
  forwardRef,
  useCallback, useContext, useEffect, useRef, useState,
} from 'react';
import {
  Alert, AlertTitle, Box, Button, Dialog, Slide, Toolbar,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import api from '../../../../api/req';
import { AppContext } from '../../../../providers/authProvider';
import Loader from '../../../../components/MaterialUI/loader';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

function PrintDialog({
  renderPage, printUrl, param, modalOpened, setModalOpened,
}) {
  const [loading, setLoading] = useState(false);

  const [err, setErr] = useState(null);
  const resultRef = useRef();
  const [result, setResult] = useState(null);
  const { auth } = useContext(AppContext);

  const onGenerateForm = useCallback(
    () => {
      const req = async () => {
        const payload = {
          id: param,
        };
        const r = await api.post(printUrl, auth, payload);
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return r.json();
      };
      setLoading(true);
      setErr(null);
      req()
        .then((d) => {
          const dd = /^data:text\/html;base64,(.*)$/gm.exec(d.file);
          setResult(decodeURIComponent(escape(atob(dd[1]))));
          resultRef.current.innerHTML = result;
        })
        .catch((e) => setErr(e.message))
        .finally(() => setLoading(false));
    },
    [auth, param, printUrl, result],
  );

  useEffect(() => {
    if (modalOpened) onGenerateForm();
  }, [modalOpened, onGenerateForm]);

  useEffect(
    () => {
      if (resultRef.current) {
        if (result) {
          resultRef.current.innerHTML = result;
        } else {
          resultRef.current.innerHTML = '';
        }
        document.getElementById('print-area').innerHTML = result;
      }
      return () => {
        document.getElementById('print-area').innerHTML = '';
      };
    },
    [result],
  );

  const printAllowed = !!result;

  return (
    <Dialog
      onClose={() => setModalOpened(false)}
      open={modalOpened}
      fullScreen
      TransitionComponent={Transition}
    >
      {loading && (
        <Loader text="Завантаження" />
      )}

      {err && (
        <Alert severity="error">
          <AlertTitle>:-(</AlertTitle>
          {err}
        </Alert>
      )}
      <Toolbar sx={{ gap: 1 }}>
        <Button
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faPrint} />}
          color="success"
          disabled={!printAllowed}
          onClick={() => window.print()}
        >
          Друк
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={() => {
            resultRef.current.innerHTML = null;
            setModalOpened(false);
            renderPage();
          }}
        >
          Закрити
        </Button>
      </Toolbar>
      <Box ref={resultRef} margin="0 15px" />
    </Dialog>
  );
}

PrintDialog.propTypes = {
  renderPage: PropTypes.func.isRequired,
  printUrl: PropTypes.string.isRequired,
  param: PropTypes.shape({}),
  modalOpened: PropTypes.bool,
  setModalOpened: PropTypes.func,
};

PrintDialog.defaultProps = {
  param: {},
  modalOpened: false,
  setModalOpened: null,
};
export default PrintDialog;
